import { render } from "./ReportRevenuePriceListIndex.vue?vue&type=template&id=9db722ea&scoped=true"
import script from "./ReportRevenuePriceListIndex.vue?vue&type=script&lang=js"
export * from "./ReportRevenuePriceListIndex.vue?vue&type=script&lang=js"

import "./ReportRevenuePriceListIndex.vue?vue&type=style&index=0&id=9db722ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db722ea"]])

export default __exports__